import React from "react";
import { Helmet } from "react-helmet-async";

import ContactHero from "../components/contact/ContactHero";
import GlobalCta from "../components/global/GlobalCta";
import ChillerTruckWhenToUse from "../components/chiller-truck/ChillerTruckWhenToUse";
import ChillerTruckFleetTable from "../components/chiller-truck/ChillerTruckFleetTable";
import ChillerTruckOperations from "../components/chiller-truck/ChillerTruckOperations";
import ChillerTruckColdChain from "../components/chiller-truck/ChillerTruckColdChain";
import ChillerTruckPricing from "../components/chiller-truck/ChillerTruckPricing";
import ChillerTruckCoverage from "../components/chiller-truck/ChillerTruckCoverage";
import ChillerTruckWhyReliable from "../components/chiller-truck/ChillerTruckWhyReliable";
import ChillerTruckFaq from "../components/chiller-truck/ChillerTruckFaq";

import { chillerTruckSections } from "../components/chiller-truck/chillerTruckSections";
import "../components/chiller-truck/chiller-truck.css";

const ChillerTruck = () => {
  const renderSection = (section, index) => {
    switch (section.type) {
      case "ct-hero":
        return (
          <ContactHero
            key={index}
            variant="chiller-truck"
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      case "ct-when-to-use":
        return (
          <ChillerTruckWhenToUse
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
            image={section.image}
            imageAlt={section.imageAlt}
          />
        );

      case "ct-fleet-table":
        return (
          <ChillerTruckFleetTable
            key={index}
            title={section.title}
            description={section.description}
            payloadRows={section.payloadRows}
            configRows={section.configRows}
          />
        );

      case "ct-operations":
        return (
          <ChillerTruckOperations
            key={index}
            title={section.title}
            description={section.description}
            operations={section.operations}
          />
        );

      case "ct-cold-chain":
        return (
          <ChillerTruckColdChain
            key={index}
            title={section.title}
            items={section.items}
            image={section.image}
            imageAlt={section.imageAlt}
          />
        );

      case "ct-pricing":
        return (
          <ChillerTruckPricing
            key={index}
            title={section.title}
            description={section.description}
            tableLabel={section.tableLabel}
            rows={section.rows}
          />
        );

      case "ct-coverage":
        return (
          <ChillerTruckCoverage
            key={index}
            title={section.title}
            description={section.description}
            dubaiZones={section.dubaiZones}
            sharjahZones={section.sharjahZones}
            note={section.note}
            image={section.image}
            imageAlt={section.imageAlt}
            eastCoastTitle={section.eastCoastTitle}
            eastCoastDescription={section.eastCoastDescription}
            eastCoastZones={section.eastCoastZones}
          />
        );

      case "ct-why-reliable":
        return (
          <ChillerTruckWhyReliable
            key={index}
            title={section.title}
            description={section.description}
            reasons={section.reasons}
          />
        );

      case "ct-faq":
        return (
          <ChillerTruckFaq
            key={index}
            title={section.title}
            faqs={section.faqs}
          />
        );

      case "cta":
        return (
          <GlobalCta
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>Chiller Truck for Rent in Dubai & Sharjah | Chiller Fleet Transport</title>
        <meta name="description" content="Hire Chiller Fleet Transport's chiller truck for rent in Dubai & Sharjah — with capacity up to 12 tons for bulk chilled cargo & warehouse distribution across UAE." />
        <link rel="canonical" href="https://chillerfleet.com/chiller-truck-for-rent" />
        <meta property="og:title" content="Chiller Truck for Rent in Dubai & Sharjah | Chiller Fleet Transport" />
        <meta property="og:description" content="Hire Chiller Fleet Transport's chiller truck for rent in Dubai & Sharjah — with capacity up to 12 tons for bulk chilled cargo & warehouse distribution across UAE." />
        <meta property="og:url" content="https://chillerfleet.com/chiller-truck-for-rent" />
        <meta name="twitter:title" content="Chiller Truck for Rent in Dubai & Sharjah | Chiller Fleet Transport" />
        <meta name="twitter:description" content="Hire Chiller Fleet Transport's chiller truck for rent in Dubai & Sharjah — with capacity up to 12 tons for bulk chilled cargo & warehouse distribution across UAE." />
      </Helmet>

      {chillerTruckSections.map(renderSection)}
    </>
  );
};

export default ChillerTruck;
